import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { pcClientService } from '../services/api';

// Tela do PC (kiosk do cliente). Rota pública /pc/:id — no .exe isso roda
// em tela cheia dentro de um webview. Clicar no jogo, no navegador, só mostra
// um aviso; no Windows um "ponte" nativa abre o .exe do jogo.
export default function PcClient() {
  const { id } = useParams();
  const machineId = parseInt(id) || 1;

  const [view, setView] = useState('login');   // login | area | nocredit
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [session, setSession] = useState(null); // {session_id, client, rate, games}
  const [packages, setPackages] = useState([]);
  const [remaining, setRemaining] = useState(0);
  const [tab, setTab] = useState('jogos');
  const [toast, setToast] = useState('');
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const timerRef = useRef();

  // Cronômetro
  useEffect(() => {
    if (view !== 'area') return;
    timerRef.current = setInterval(() => {
      setRemaining((s) => {
        if (s <= 1) { clearInterval(timerRef.current); doLogout('time'); return 0; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line
  }, [view]);

  const doLogin = async (e) => {
    e?.preventDefault();
    if (!login || !password) { setError('Preencha usuário e senha'); return; }
    setBusy(true); setError('');
    try {
      const { data } = await pcClientService.login({ machine_id: machineId, login, password });
      if (data.no_credit) {
        setPackages(data.packages || []);
        setSession({ client: data.client });
        setView('nocredit');
      } else {
        setSession(data);
        setPackages(data.packages || []);
        setRemaining(data.remaining_seconds || 0);
        setTab('jogos');
        setView('area');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Falha no login');
    } finally { setBusy(false); }
  };

  const doLogout = async (reason) => {
    const sid = session?.session_id;
    clearInterval(timerRef.current);
    if (sid) { try { await pcClientService.logout({ session_id: sid }); } catch (_) {} }
    setSession(null); setPassword(''); setLogin(''); setRemaining(0);
    setView('login');
  };

  const openGame = (g) => {
    // No navegador só simula; no webview do Windows a ponte abre o .exe.
    setToast(`🎮 Abriria: ${g.name}`);
    setTimeout(() => setToast(''), 1800);
  };

  const fmt = (s) => {
    s = Math.max(0, s); const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
    return h ? `${h}:${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}` : `${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
  };
  const money = (v) => `R$ ${Number(v || 0).toFixed(2)}`.replace('.', ',');
  const timerColor = remaining > 120 ? C.green : remaining > 30 ? C.amber : C.red;

  // ---------------- LOGIN ----------------
  if (view === 'login' || view === 'nocredit') {
    return (
      <div style={st.wrap}>
        <img src="/logo.png" alt="Arena" style={st.logo} />
        {view === 'login' ? (
          <>
            <div style={st.sub}>Entre com sua conta para jogar</div>
            <form onSubmit={doLogin} style={st.card}>
              <input style={st.input} placeholder="Nick ou WhatsApp" value={login} onChange={e => setLogin(e.target.value)} autoFocus />
              <input style={st.input} placeholder="Senha" type="password" value={password} onChange={e => setPassword(e.target.value)} />
              <button style={st.btn} disabled={busy}>{busy ? 'ENTRANDO…' : 'ENTRAR'}</button>
              {error && <div style={st.err}>{error}</div>}
            </form>
          </>
        ) : (
          <div style={{ ...st.card, borderColor: C.amber, width: 420 }}>
            <div style={{ color: C.amber, fontWeight: 700, fontSize: 17, marginBottom: 4 }}>
              {session?.client?.name ? session.client.name + ', ' : ''}seu saldo acabou
            </div>
            <div style={{ color: C.muted, fontSize: 13, marginBottom: 12 }}>Compre crédito no caixa ou escaneie o QR (em breve):</div>
            {packages.map(p => (
              <div key={p.id} style={st.pkg}><span>{p.name}</span><b style={{ color: C.green }}>{money(p.price)}</b></div>
            ))}
            <button style={{ ...st.btn, marginTop: 14 }} onClick={() => { setView('login'); setError(''); }}>Voltar</button>
          </div>
        )}
        <div style={st.machine}>PC {machineId}</div>
      </div>
    );
  }

  // ---------------- ÁREA DO CLIENTE ----------------
  const games = session?.games || [];
  return (
    <div style={st.appWrap}>
      <div style={st.topbar}>
        <img src="/logo.png" alt="Arena" style={{ height: 34 }} />
        <span style={st.who}>· {session?.client?.name}</span>
        <div style={{ flex: 1 }} />
        <span style={{ color: C.green, fontWeight: 700, fontSize: 16 }}>{money(session?.client?.balance)}</span>
        <span style={{ color: timerColor, fontWeight: 800, fontSize: 26, margin: '0 18px' }}>{fmt(remaining)}</span>
        <button style={st.sair} onClick={() => doLogout('manual')}>Sair</button>
      </div>

      <div style={st.tabs}>
        <button style={{ ...st.tab, ...(tab === 'jogos' ? st.tabOn : {}) }} onClick={() => setTab('jogos')}>🎮 Jogos</button>
        <button style={{ ...st.tab, ...(tab === 'saldo' ? st.tabOn : {}) }} onClick={() => setTab('saldo')}>💰 Saldo</button>
      </div>

      {tab === 'jogos' ? (
        <div style={st.grid}>
          {games.map(g => (
            <button key={g.id} style={st.tile} onClick={() => openGame(g)}>
              {g.icon_url ? <img src={g.icon_url} alt="" style={st.tileImg} /> : <div style={st.tileIcon}>🎮</div>}
              <div style={st.tileName}>{g.name}</div>
            </button>
          ))}
          {!games.length && <div style={{ color: C.muted, padding: 40 }}>Nenhum jogo cadastrado.</div>}
        </div>
      ) : (
        <div style={{ padding: 40 }}>
          <div style={st.saldoCard}>
            <div style={{ color: C.muted, fontSize: 12, fontWeight: 600, letterSpacing: 2 }}>SALDO DISPONÍVEL</div>
            <div style={{ color: C.green, fontSize: 44, fontWeight: 800 }}>{money(session?.client?.balance)}</div>
            <div style={{ color: C.text, fontSize: 15, marginTop: 10 }}>Tempo restante: {fmt(remaining)}</div>
          </div>
          <div style={{ color: C.muted, fontSize: 13, marginTop: 14 }}>Precisa de mais tempo? Fale com o atendente para adicionar crédito.</div>
        </div>
      )}

      {toast && <div style={st.toast}>{toast}</div>}
    </div>
  );
}

const C = { bg: '#0a0a0f', panel: '#14141f', panelLt: '#1c1c2b', accent: 'var(--accent)', green: '#22c55e', amber: '#f59e0b', red: '#ef4444', text: '#f5f5f7', muted: '#7b7b8a' };
const st = {
  wrap: { minHeight: '100vh', background: C.bg, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, fontFamily: 'Segoe UI, Arial, sans-serif' },
  logo: { width: 380, maxWidth: '80vw', height: 'auto' },
  sub: { color: C.muted, fontSize: 15, marginBottom: 10 },
  card: { background: C.panel, border: '1px solid #262636', borderRadius: 16, padding: 26, width: 360, maxWidth: '90vw', display: 'flex', flexDirection: 'column', gap: 12 },
  input: { background: C.panelLt, border: '1px solid #34344e', borderRadius: 8, color: C.text, fontSize: 15, padding: '11px 12px', outline: 'none' },
  btn: { background: C.accent, color: '#0a0a0f', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 800, padding: 12, cursor: 'pointer' },
  err: { color: C.red, fontSize: 13, textAlign: 'center' },
  pkg: { display: 'flex', justifyContent: 'space-between', color: C.text, fontSize: 14, padding: '5px 0' },
  machine: { color: C.accent, fontSize: 14, fontWeight: 700, marginTop: 34 },
  appWrap: { minHeight: '100vh', background: C.bg, fontFamily: 'Segoe UI, Arial, sans-serif' },
  topbar: { height: 72, background: C.panel, borderBottom: '1px solid #262636', display: 'flex', alignItems: 'center', padding: '0 24px' },
  who: { color: C.text, fontSize: 15, marginLeft: 12 },
  sair: { background: 'transparent', color: C.muted, border: '1px solid #374151', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  tabs: { display: 'flex', gap: 6, background: C.panel, padding: '0 24px' },
  tab: { background: 'transparent', color: C.muted, border: 'none', borderBottom: '3px solid transparent', padding: '14px 18px', fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  tabOn: { color: C.accent, borderBottom: `3px solid ${C.accent}` },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 20, padding: 32 },
  tile: { background: C.panel, border: '1px solid #262636', borderRadius: 16, height: 180, cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, color: C.text },
  tileImg: { width: 96, height: 96, objectFit: 'cover', borderRadius: 12 },
  tileIcon: { fontSize: 54 },
  tileName: { fontSize: 14, fontWeight: 600 },
  saldoCard: { background: C.panel, border: '1px solid #262636', borderRadius: 16, padding: 28, maxWidth: 460 },
  toast: { position: 'fixed', bottom: 40, left: '50%', transform: 'translateX(-50%)', background: C.accent, color: '#0a0a0f', fontWeight: 700, padding: '12px 24px', borderRadius: 30, fontSize: 16 },
};
